
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

// Namespace list can be extended
const namespaces = ['common'];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'vi', 'zh', 'th', 'ko', 'ja'],
    lng: 'en',
    ns: namespaces,
    defaultNS: 'common',
    debug: true, // Temporarily enabled for production debugging
    interpolation: {
      escapeValue: false,
    },
    backend: {
      // Path for loading translation files
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      requestOptions: {
        cache: 'no-cache', // Prevent caching issues during development
      },
      allowMultiLoading: false,
      crossDomain: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
    // Disabled missing key handler to stop warning logs
    saveMissing: false,
    // Removed missingKeyHandler to stop console warnings
    react: {
      useSuspense: false, // Disable suspense to prevent blocking
    },
    initImmediate: false, // Don't wait for backend
    load: 'languageOnly', // Faster loading
    preload: ['en'], // Preload English to ensure at least one language is available
  });

// Removed all event listeners to stop console logging:
// - i18n.on('initialized')
// - i18n.on('loaded') 
// - i18n.on('failedLoading')
// - i18n.on('languageChanged')

export default i18n;
